import React from "react";
import styles from "./Contacts.module.scss";
import cn from "classnames";
import contactsData from '../../data/contactsData.json';

interface ContactsProps {
    className?: string,
}

const Contacts: React.FC<ContactsProps> = ({className}) => {
    return (
        <div className={cn(className, styles.contacts)}>
            {contactsData.map((contact) =>
                <a key={contact.id} href={`${contact.typeLink}:${contact.link}`} className={styles.contactItem}>
                    <p className={styles.contactTitle}>{contact.title}</p>
                    <p className={styles.contactText}>{contact.text}</p>
                </a>
            )}
        </div>
    )
}

export default Contacts;